import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Switch,
  Row,
  Col,
  Card,
  Badge
} from '@lockerpm/design';

import {
  UnlockOutlined,
  SecurityScanOutlined,
  SettingOutlined
} from "@ant-design/icons";

import global from "../../../../config/global";
import { convertDateTime } from "../../../../utils/common"

const Security = () => {
  const { t } = useTranslation();

  const factor2 = useSelector((state) => state.auth.factor2);
  const userInfo = useSelector(state => state.auth.userInfo);

  const smartOtp = useMemo(() => {
    return factor2.user_factor2_infos.find((i) => i.method === 'smart_otp')
  }, [factor2])

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col lg={12} md={12} sm={12} xs={24}>
          <Card
            bodyStyle={{ padding: 16 }}
            hoverable
            onClick={() => global.navigate('ACCOUNT_CHANGE_PASSWORD')}
          >
            <div>
              <UnlockOutlined />
            </div>
            <p className="font-semibold">
              {t('account_details.change_password')}
            </p>
          </Card>
        </Col>
        <Col lg={12} md={12} sm={12} xs={24}>
          <Card
            bodyStyle={{ padding: 16 }}
            hoverable
            onClick={() => global.navigate('ACCOUNT_2FA')}
          >
            <div className="flex justify-between">
              <SecurityScanOutlined />
              <Switch checked={smartOtp?.is_active} onChange={() => {}} />
            </div>
            <p className="font-semibold">
              {t('account_details.2fa.setup')}
            </p>
          </Card>
          <div className="flex items-center text-xs mt-1">
            <p>
              {t('account_details.2fa.setup_on')}
            </p>
            <Badge
              className="mx-2"
              status={smartOtp.is_active ? 'success' : 'default'}
            />
            <p>
              {t(`common.${smartOtp.is_active ? 'on' : 'off'}`)} <span>
                {
                  smartOtp.revision_date && `(${convertDateTime(smartOtp.revision_date)})`
                }
              </span>
            </p>
          </div>
        </Col>
        {
          userInfo?.kdf_version >= 1 && <Col lg={12} md={12} sm={12} xs={24}>
            <Card
              bodyStyle={{ padding: 16 }}
              hoverable
              onClick={() => global.navigate('ACCOUNT_UPDATE_ENCRYPTION')}
            >
              <div>
                <SettingOutlined />
              </div>
              <p className="font-semibold">
                {t('account_details.update_encryption')}
              </p>
            </Card>
          </Col>
        }
      </Row>
    </div>
  );
}

export default Security;